import { type FormInput, FormInputComponents } from '../support.type';
import { FormField } from './FormField';

export class FormFieldInput extends FormField<string> {
    private readonly inputRegExp;
    readonly multiline: boolean = false;
    constructor(input: FormInput) {
        super(input);
        this._value = input.value;
        this.inputRegExp = new RegExp(input.regexPattern || '.*');
        this.multiline = input.formInputType === 'MultilineText';
    }

    override component = FormInputComponents.MrInput;

    get data() {
        return this.value ?? '';
    }

    override validator(val: string | null) {
        const validator = super.validator(val);
        if (validator !== true) {
            return validator;
        }
        const isValid = !!this.inputRegExp?.test(val!);
        this._isValid = isValid;
        return isValid ? true : 'مقدار وارد شده معتبر نیست.';
    }
}
